import React from 'react';
import { Select, T } from '@colonist/ui';
import styles from './RegionSelectField.module.scss';
/** Vertical label + Select pair for form fields. */ export const RegionSelectField = ({ label, value, onSelect, disabled = false, children })=>/*#__PURE__*/ React.createElement("label", {
        className: styles.selectField
    }, /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(T, {
        id: label
    })), /*#__PURE__*/ React.createElement(Select, {
        value: value,
        onSelect: onSelect,
        disabled: disabled
    }, children));
